// eslint-disable-next-line max-classes-per-file
import { InfrastructureError } from '@goodt-wcore/errors';

export class DataClientRequestError extends InfrastructureError {
    context;

    constructor(message, { code, data, reason } = {}) {
        super(message, { code, data, reason });
        this.name = 'DataClientRequestError';
    }
}